var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20833 12.5H3.125L12.5 3.125L21.875 12.5H19.7917M5.20833 12.5V19.7917C5.20833 20.3442 5.42783 20.8741 5.81853 21.2648C6.20923 21.6555 6.73913 21.875 7.29167 21.875H17.7083C18.2609 21.875 18.7908 21.6555 19.1815 21.2648C19.5722 20.8741 19.7917 20.3442 19.7917 19.7917V12.5",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 21.875V15.625C9.375 15.0725 9.59449 14.5426 9.98519 14.1519C10.3759 13.7612 10.9058 13.5417 11.4583 13.5417H13.5417C14.0942 13.5417 14.6241 13.7612 15.0148 14.1519C15.4055 14.5426 15.625 15.0725 15.625 15.625V21.875",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4c56f0bd93df2632e18ec1573f24a0a2.svg";
export { ForwardRef as ReactComponent };